'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  bottom: -18px;\n  width: calc(100% + 64px);\n  height: 18px;\n  border-radius: 2px;\n  background: grey;\n'], ['\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  bottom: -18px;\n  width: calc(100% + 64px);\n  height: 18px;\n  border-radius: 2px;\n  background: grey;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  bottom: -8px;\n  width: 100px;\n  height: 8px;\n  background: #333;\n'], ['\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  bottom: -8px;\n  width: 100px;\n  height: 8px;\n  background: #333;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _rebass = require('rebass');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Keyboard = (0, _styledComponents2.default)(_rebass.Box)(_templateObject);
var KeyboardNotch = (0, _styledComponents2.default)(_rebass.Box)(_templateObject2);

var Laptop = function Laptop(_ref) {
  var _ref$src = _ref.src,
      src = _ref$src === undefined ? 'https://via.placeholder.com/640x400' : _ref$src,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ['src', 'style', 'children']);

  return _react2.default.createElement(
    _rebass.Box,
    _extends({ bg: 'black', p: 3, style: _extends({
        borderRadius: 4,
        border: '1px solid grey',
        position: 'relative',
        transform: 'scale(0.8)'
      }, style) }, props),
    src ? _react2.default.createElement(_rebass.Image, { src: src }) : children,
    _react2.default.createElement(Keyboard, null),
    _react2.default.createElement(KeyboardNotch, null)
  );
};

Laptop.displayName = 'Laptop';
Laptop.propTypes = {
  src: _propTypes2.default.string,
  style: _propTypes2.default.object,
  children: _propTypes2.default.any
};
exports.default = Laptop;